import { darkTheme, lightTheme } from "../../../app/appTheme";
export function getAllAdaptiveCardWidgetStyles(isThemeDark, size, height, width) {
    let styles = `
   .ac-container.ac-adaptiveCard
    {
        height: size.acContainer.height;
        width: size.acContainer.width;
        background: linear-gradient(theme.customSemanticColors.cardBackgroundSecondary, theme.customSemanticColors.cardBackgroundSecondary),
                    linear-gradient(theme.customSemanticColors.solidBackgroundQuarternary, theme.customSemanticColors.solidBackgroundQuarternary);
        border-radius: 8px;
        box-sizing: border-box;
        line-height: normal;
        margin: 0px 0px 0px 0px;
        padding: 48px 16px 16px 16px !important;
        position: relative;
    }

    .ac-container
    {
        padding: 0px !important;
    }

    .ac-container.ac-selectable, .ac-columnSet.ac-selectable
    {
        background-blend-mode: lighten;
        background-color: theme.customSemanticColors.subtleFillTransparent;
        border-radius: 4px;
        line-height: initial;
        overflow: inherit !important;
        cursor: pointer;
    }

    /* Checkboxes */
    .ac-input.ac-choiceSetInput-multiSelect input[type='checkbox']
    {
        align-items: center;
        background-color: theme.customSemanticColors.controlAltFillSecondary;
        border: 1px solid;
        border-color: theme.customSemanticColors.controlStrongStrokeDefault;
        border-radius: 3px;
        box-shadow: none;
        font-family: "Segoe Fluent Icons";
        font-size: 12px;
        height: 18px;
        justify-content: center;
        -webkit-appearance: none;
        -moz-appearance: none;
        -o-appearance: none;
        text-align: center;
        width: 18px;
        margin: 3px !important;
        padding: 1px;
        vertical-align: center;
    }

    .ac-input.ac-choiceSetInput-multiSelect input[type=checkbox]:active
    {
        background-color: theme.customSemanticColors.accentFillTertiary;
        border-color: theme.customSemanticColors.accentFillTertiary;
    }
    .ac-input.ac-choiceSetInput-multiSelect input[type=checkbox]:checked
    {
        background-color: theme.customSemanticColors.accentFillDefault;
        border-color: theme.customSemanticColors.accentFillDefault;
    }
    .ac-input.ac-choiceSetInput-multiSelect input[type=checkbox]:checked::after
    {
        content: "\\F78C";
        color: theme.customSemanticColors.textOnAccentPrimary;
    }
    .ac-input.ac-choiceSetInput-multiSelect input[type=checkbox]:hover
    {
        background-color: theme.customSemanticColors.controlAltFillTertiary;
        border-color: theme.customSemanticColors.controlStrongStrokeDefault;
        cursor: pointer;
    }
    .ac-input.ac-choiceSetInput-multiSelect input[type=checkbox]:checked::hover
    {
        background-color: theme.customSemanticColors.accentFillDefault;
        border-color: theme.customSemanticColors.accentFillDefault;
    }

    /* Radio buttons */
    .ac-input.ac-choiceSetInput-expanded input[type=radio]
    {
        align-items: center;
        background-color: theme.customSemanticColors.controlAltFillSecondary;
        border: 1px solid;
        border-color: theme.customSemanticColors.controlStrongStrokeDefault;
        border-radius: 999px;
        box-shadow: none;
        font-family: "Segoe Fluent Icons";
        font-size: 18px;
        height: 18px;
        justify-content: center;
        "-webkit-appearance": none;
        "-moz-appearance": none;
        "-o-appearance": none;
        "text-align": center;
        width: 18px;
        margin: 3px !important;
        vertical-align: center;
    }
    .ac-input.ac-choiceSetInput-expanded input[type=radio]:checked:active
    {
        background-color: theme.customSemanticColors.accentFillTertiary;
        border-color: theme.customSemanticColors.accentFillTertiary;
    }
    .ac-input.ac-choiceSetInput-expanded input[type=radio]:checked:after
    {
        background-color: theme.customSemanticColors.accentFillDefault;
        border-radius: 999px;
        border-color: theme.customSemanticColors.accentFillDefault;
        content: "\\E915";
        color: theme.customSemanticColors.textOnAccentPrimary;
    }
    .ac-input.ac-choiceSetInput-expanded input[type=radio]:checked:hover
    {
        background-color: theme.customSemanticColors.accentFillSecondary;
        border-color: theme.customSemanticColors.accentFillSecondary;
        cursor: pointer;
    }
    .ac-input.ac-choiceSetInput-expanded input[type=radio]:hover
    {
        background-color: theme.customSemanticColors.controlAltFillTertiary;
        border-color: theme.customSemanticColors.controlStrongStrokeDefault;
    }

    /* Push button */
    .ac-pushButton
    {
        background: theme.customSemanticColors.accentFillDefault;
        border-radius: 4px;
        border-width: 0px;
        box-shadow: none;
        color: theme.customSemanticColors.textOnAccentPrimary;
        cursor: pointer;
        height: 32px;
        padding: 5px 12px 5px;
        max-width: calc(size.acContainer.width - 32px);
    }
    .ac-pushButton:hover
    {
        background: theme.customSemanticColors.accentFillSecondary;
    }
    .ac-pushButton:active
    {
        background: theme.customSemanticColors.accentFillTertiary;
    }
    .ac-pushButton:focus
    {
        borderColor: theme.customSemanticColors.focusOuter;
    }
    .ac-pushButton:disabled
    {
        background: theme.customSemanticColors.accentDisabled;
        border-radius: 4px;
        border-width: 0px;
        box-shadow: none;
        color: theme.customSemanticColors.textOnAccentPrimary;
        cursor: pointer;
        height: 32px;
        padding: 5px 12px 7px;
        max-width: calc(size.acContainer.width - 32px);
    }

    /* Hyperlinks */
    a.ac-anchor
    {
        color: theme.customSemanticColors.accentTextPrimary;
        text-decoration: underline;
    }
    a.ac-anchor:active
    {
        color: theme.customSemanticColors.accentFillTertiary;
        text-decoration: none;
    }
    a.ac-anchor:focus, a.ac-anchor:focus-visible
    {
        border-radius: 4px;
        box-shadow: 0 0 0 3px theme.customSemanticColors.focusOuter;
        outline: 1px solid transparent;
    }
    a.ac-anchor:hover
    {
        color: theme.customSemanticColors.accentTextSecondary;
        text-decoration: none;
    }

    /* Image and media */
    .ac-image, .ac-media
    {
        border-radius: 4px;
        overflow: hidden;
    }
    .ac-image:video, .ac-media:video
    {
        border-radius: 4px;
    }

    .swiper
    {
        margin-left: auto;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        list-style: none;
        padding: 0;
        /* Fix of Webkit flickering */
        z-index: 1;
    }

    .swiper-vertical > .swiper-wrapper
    {
        flex-direction: column;
    }
    .swiper-wrapper
    {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: flex;
        transition-property: transform;
        box-sizing: content-box;
    }
    .swiper-android .swiper-slide,
    .swiper-wrapper
    {
        transform: translate3d(0px, 0, 0);
    }

    .swiper-pointer-events
    {
        touch-action: pan-y;
    }
    .swiper-pointer-events.swiper-vertical
    {
        touch-action: pan-x;
    }

    .swiper-slide
    {
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        position: relative;
        transition-property: transform;
    }
    .swiper-slide-invisible-blank
    {
        visibility: hidden;
    }

    /* Auto Height */
    .swiper-autoheight,
    .swiper-autoheight .swiper-slide
    {
        height: auto;
    }
    .swiper-autoheight .swiper-wrapper
    {
        align-items: flex-start;
        transition-property: transform, height;
    }

    /* 3D Effects */
    .swiper-3d, .swiper-3d.swiper-css-mode .swiper-wrapper
    {
        perspective: 1200px;
    }
    .swiper-3d .swiper-wrapper,
    .swiper-3d .swiper-slide,
    .swiper-3d .swiper-slide-shadow,
    .swiper-3d .swiper-slide-shadow-left,
    .swiper-3d .swiper-slide-shadow-right,
    .swiper-3d .swiper-slide-shadow-top,
    .swiper-3d .swiper-slide-shadow-bottom,
    .swiper-3d .swiper-cube-shadow
    {
        transform-style: preserve-3d;
    }
    .swiper-3d .swiper-slide-shadow,
    .swiper-3d .swiper-slide-shadow-left,
    .swiper-3d .swiper-slide-shadow-right,
    .swiper-3d .swiper-slide-shadow-top,
    .swiper-3d .swiper-slide-shadow-bottom
    {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 10;
    }

    .swiper-3d .swiper-slide-shadow
    {
        background: rgba(0, 0, 0, 0.15);
    }
    .swiper-3d .swiper-slide-shadow-left
    {
        background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    }
    .swiper-3d .swiper-slide-shadow-right
    {
        background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    }
    .swiper-3d .swiper-slide-shadow-top
    {
        background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    }
    .swiper-3d .swiper-slide-shadow-bottom
    {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    }

    /* CSS Mode */
    .swiper-css-mode > .swiper-wrapper
    {
        overflow: auto;
        scrollbar-width: none;
        /* For Firefox */
        -ms-overflow-style: none;
        /* For Internet Explorer and Edge */
    }
    .swiper-css-mode > .swiper-wrapper::-webkit-scrollbar
    {
        display: none;
    }
    .swiper-css-mode > .swiper-wrapper > .swiper-slide
    {
        scroll-snap-align: start start;
    }

    .swiper-horizontal.swiper-css-mode > .swiper-wrapper
    {
        scroll-snap-type: x mandatory;
    }

    .swiper-vertical.swiper-css-mode > .swiper-wrapper
    {
        scroll-snap-type: y mandatory;
    }

    .swiper-centered > .swiper-wrapper::before
    {
        content: "";
        flex-shrink: 0;
        order: 9999;
    }
    .swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child
    {
        margin-inline-start: var(--swiper-centered-offset-before);
    }
    .swiper-centered.swiper-horizontal > .swiper-wrapper::before
    {
    height: 100%;
        width: var(--swiper-centered-offset-after);
    }
    .swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child
    {
        margin-block-start: var(--swiper-centered-offset-before);
    }
    .swiper-centered.swiper-vertical > .swiper-wrapper::before
    {
    width: 100%;
        height: var(--swiper-centered-offset-after);
    }
    .swiper-centered > .swiper-wrapper > .swiper-slide
    {
        scroll-snap-align: center center;
    }
    .swiper-pagination
    {
        position: absolute;
        text-align: center;
        transition: 300ms opacity;
        transform: translate3d(0, 0, 0);
        z-index: 10;
    }
    .swiper-pagination.swiper-pagination-hidden
    {
        opacity: 0;
    }

     /* Common Styles */
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal
    {
        bottom: 10px;
        left: 0;
        width: 100%;
    }

    /* Bullets */
    .swiper-pagination-bullets-dynamic
    {
        overflow: hidden;
        font-size: 0;
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet
    {
        transform: scale(0.33);
        position: relative;
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active
    {
        transform: scale(1);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main
    {
        transform: scale(1);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev
    {
        transform: scale(0.66);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev
    {
        transform: scale(0.33);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next
    {
        transform: scale(0.66);
    }
    .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next
    {
        transform: scale(0.33);
    }

    .swiper-pagination-bullet
    {
        width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
        height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
        display: inline-block;
        border-radius: 50%;
        background: var(--swiper-pagination-bullet-inactive-color, #000);
        opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
    }
    button.swiper-pagination-bullet
    {
        border: none;
        margin: 0;
        padding: 0;
        box-shadow: none;
        appearance: none;
    }

    .swiper-pagination-clickable .swiper-pagination-bullet
    {
        cursor: pointer;
    }
    .swiper-pagination-bullet:only-child
    {
        display: none !important;
    }

    .swiper-pagination-bullet-active
    {
        opacity: var(--swiper-pagination-bullet-opacity, 1);
        background: var(--swiper-pagination-color, var(--swiper-theme-color));
    }

    .swiper-vertical > .swiper-pagination-bullets,
    .swiper-pagination-vertical.swiper-pagination-bullets
    {
        right: 10px;
        top: 50%;
        transform: translate3d(0px, -50%, 0);
    }
    .swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet
    {
        margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
        display: block;
    }
    .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
    .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    {
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
    }
    .swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
    .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet
    {
        display: inline-block;
        transition: 200ms transform, 200ms top;
    }

    .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet
    {
        margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
    }
    .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic
    {
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
    }
    .swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
    .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet
    {
        transition: 200ms transform, 200ms left;
    }

    .swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet
    {
        transition: 200ms transform, 200ms right;
    }

    /* Progress */
    .swiper-pagination-progressbar
    {
        background: rgba(0, 0, 0, 0.25);
        position: absolute;
    }
    .swiper-pagination-progressbar .swiper-pagination-progressbar-fill
    {
        background: var(--swiper-pagination-color, var(--swiper-theme-color));
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        transform: scale(0);
        transform-origin: left top;
    }
    .swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill
    {
        transform-origin: right top;
    }
    .swiper-horizontal > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-horizontal,
    .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
    .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite
    {
        width: 100%;
        height: 4px;
        left: 0;
        top: 0;
    }
    .swiper-vertical > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-vertical,
    .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,
    .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite
    {
        width: 4px;
        height: 100%;
        left: 0;
        top: 0;
    }

    .swiper-pagination-lock
    {
        display: none;
    }

    :root
    {
        --swiper-navigation-size: 44px;
        /*
        --swiper-navigation-color: var(--swiper-theme-color);
        */
    }

    .swiper-button-prev,
    .swiper-button-next
    {
        position: absolute;
        top: 50%;
        width: calc(var(--swiper-navigation-size) / 44 * 27);
        height: var(--swiper-navigation-size);
        margin-top: calc(0px - var(--swiper-navigation-size) / 2);
        z-index: 10;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--swiper-navigation-color, var(--swiper-theme-color));
    }
    .swiper-button-prev.swiper-button-disabled,
    .swiper-button-next.swiper-button-disabled
    {
        opacity: 0.35;
        cursor: auto;
        pointer-events: none;
    }
    .swiper-button-prev:after,
    .swiper-button-next:after
    {
        font-family: swiper-icons;
        font-size: var(--swiper-navigation-size);
        text-transform: none !important;
        letter-spacing: 0;
        text-transform: none;
        font-variant: initial;
        line-height: 1;
    }

    .swiper-button-prev,
    .swiper-rtl .swiper-button-next
    {
        left: 10px;
        right: auto;
    }
    .swiper-button-prev:after,
    .swiper-rtl .swiper-button-next:after
    {
        content: "prev";
    }

    .swiper-button-next,
    .swiper-rtl .swiper-button-prev
    {
        right: 10px;
        left: auto;
    }
    .swiper-button-next:after,
    .swiper-rtl .swiper-button-prev:after
    {
        content: "next";
    }

    .swiper-button-lock
    {
        display: none;
    }

    .swiper-pagination-bullet
    {
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        color: #000;
    }

    .swiper-slide.swiper-slide-active.ac-carousel-page
    {
        visibility: visible;
    }
    .swiper-slide.ac-carousel-page
    {
        text-align: center;
        font-size: 18px;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        visibility: hidden;
    }

    .swiper-button-next.ac-carousel-right::after
    {
        font-family: "Segoe Fluent Icons";
        font-size: 8px;
        border-radius: 3px;
        height: 38px;
        content: "\\edda";
        color: theme.customSemanticColors.controlStrongFillDefault;
    }
    .swiper-button-next.ac-carousel-right:hover
    {
        background-color: transparent;
    }
    .swiper-button-next.ac-carousel-right:hover::after
    {
        color: theme.customSemanticColors.textSecondary
    }

    .swiper-button-next.ac-carousel-right:active::after
    {
        color: theme.customSemanticColors.textSecondary
    }

    .swiper-button-prev.ac-carousel-left::after
    {
        font-family: "Segoe Fluent Icons";
        font-size: 8px;
        border-radius: 3px;
        height: 38px;
        content: "\\edd9";
        color: theme.customSemanticColors.controlStrongFillDefault
    }
    .swiper-button-prev.ac-carousel-left:hover
    {
        background-color: transparent;
    }
    .swiper-button-prev.ac-carousel-left:hover::after
    {
        color: theme.customSemanticColors.textSecondary
    }
    .swiper-button-prev.ac-carousel-left:activer::after
    {
        color: theme.customSemanticColors.textSecondary
    }

    .swiper-button-next,
    .swiper-rtl.swiper-button-prev
    {
        right: 0px;
    }

    .swiper-button-prev,
    .swiper-rtl.swiper-button-next
    {
        left: 0px;
    }

    .ac-carousel-pagination.swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal
    {
        bottom: 0px;
    }

    .ac-container.ac-carousel-page-container
    {
        width: 100%;
    }

    .ac-carousel-container
    {
        position: relative;
        padding-left: 50px;
        padding-right: 50px;
        padding-bottom: 50px;
    }

    .ac-carousel-container
    {
        padding: 0px 16px 16px 16px;
        margin: 0px -16px -16px -16px;
    }

    .ac-carousel-container:hover
    {
        border-radius: 4px;
    }

    .swiper-slide.ac-carousel-page
    {
        background: transparent !important;
    }

    .ac-container.ac-selectable:hover, .ac-columnSet.ac-selectable:hover
    {
        background-color: theme.customSemanticColors.subtleFillSecondary !important;
        border-radius: 4px;
        cursor: pointer;
    }

    .ac-container.ac-adaptiveCard .swiper-button-prev.ac-carousel-left,
    .ac-container.ac-adaptiveCard .swiper-button-next.ac-carousel-right
    {
        display: none;
    }

    .ac-container.ac-adaptiveCard:hover .swiper-button-prev.ac-carousel-left,
    .ac-container.ac-adaptiveCard:hover .swiper-button-next.ac-carousel-right,
    .ac-container.ac-adaptiveCard:focus .swiper-button-prev.ac-carousel-left,
    .ac-container.ac-adaptiveCard:focus .swiper-button-next.ac-carousel-right
    {
        display: flex;
    }

    .swiper-button-prev.ac-carousel-left,
    .swiper-button-next.ac-carousel-right
    {
        border-radius:3px;
        height:38px;
        width:16px;
    }

    .swiper-pagination-bullet
    {
        background: theme.customSemanticColors.controlStrongFillDefault;
        height: 4px;
        width: 4px;
        vertical-align: middle;
        position: relative;
    }

    .swiper-pagination-bullet::after
    {
        content:'';
        position: absolute;
        top:-4px; bottom: -4px;
        left:-4px; right:-4px;
    }

    .swiper-pagination-bullet:hover
    {
        background: theme.customSemanticColors.textSecondary;
    }

    .swiper-pagination-bullet.swiper-pagination-bullet-active
    {
        height: 6px;
        width: 6px;
    }

    @media(forced-colors: active)
    {
        .swiper-pagination-bullet
        {
            background-color: ButtonBorder !important;
        }
        .ac-input.ac-dateInput::-webkit-calendar-picker-indicator
        {
            color-scheme: theme.customSemanticColors.colorScheme;
        }
    }
    `;
    // Update styles based on the theme
    let regEx = /theme.customSemanticColors.[a-zA-z]+/g;
    const theme = isThemeDark ? darkTheme() : lightTheme();
    let match = styles.match(regEx);
    if (match && (match === null || match === void 0 ? void 0 : match.length) > 0) {
        match.forEach((m) => {
            styles = styles === null || styles === void 0 ? void 0 : styles.replace(new RegExp(m, "g"), theme.customSemanticColors[m.split(".")[2]]);
        });
    }
    // Update styles based on the size
    styles = styles === null || styles === void 0 ? void 0 : styles.replace(new RegExp("size.acContainer.height", "g"), height);
    styles = styles === null || styles === void 0 ? void 0 : styles.replace(new RegExp("size.acContainer.width", "g"), width);
    return styles;
}
